import React, { FC, useState, useEffect, useCallback } from "react";
import { Icon, IconButton } from "@material-ui/core";
import { v4 } from "uuid";
import { OrderCompositionItem } from "domains/order/agreggates/order/OrderCompositionItem";
import { useCartStore } from "modules/cart/infra/store/CartStore";
import { ICartContext } from "modules/cart/domain/interfaces/IUseCaseCart";
import { Product } from "domains/catalog/aggregates/Product";
import { OrderComposition } from "domains/order/agreggates/order/OrderComposition";
import styles from "./ProductDetail.module.scss";
import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import { CompositionList } from "../compositionList/CompositionList";
import { useTranslation } from "i18n/useTranslation";

interface ProductDetailProps {
  product: Product;
  onClose: () => void;
}

export const ProductDetail: FC<ProductDetailProps> = ({ product, onClose }) => {
  const { resolution } = useScreenStore();
  const { getProductName } = useTranslation();
  const [addProductCart] = useCartStore((state: ICartContext) => [
    state.addProductCart,
  ]);
  const [orderCompositions, setOrderCompositions] = useState<
    OrderComposition[]
  >([]);
  const [observationField, setObservationField] = useState({ observation: "" });
  const [selectedItemsFree, setSelectedItemsFree] = useState<
    OrderCompositionItem[]
  >([]);
  const [selectedItemsReplica, setSelectedItemsReplica] = useState<
    OrderCompositionItem[]
  >([]);
  const [descriptionObject, setdescriptionObject] = useState<{
    description?: string;
    qrCode?: string;
  }>();

  useEffect(() => {
    try {
      const objectDescription = JSON.parse(product.description ?? "");
      setdescriptionObject(objectDescription);
    } catch (error) {
      if (product.description && product.description.length > 0) {
        setdescriptionObject({
          description: product.description,
          qrCode: undefined,
        });
      }
    }

    try {
      if (product.compositions && product.compositions.length > 0) {
        for (const composition of product.compositions) {
          if (composition.compositionItems.length > 0) {
            for (const compositionItem of composition.compositionItems) {
              if (
                compositionItem.compositionId === null ||
                compositionItem.compositionId === undefined ||
                compositionItem.compositionId === "" ||
                compositionItem.compositionId ===
                  "00000000-0000-0000-0000-000000000000"
              ) {
                compositionItem.compositionId = composition.id;
              }
            }
          }
        }
      }
    } catch (error) {
      // console.log("not object description", error)
    }
    // console.log('Produto', produto)
  }, [product]);

  const getTotalItemsFree = () => {
    let tot = 0;
    if (selectedItemsFree.length <= 0) {
      return tot;
    } else {
      for (let z = 0; z < selectedItemsFree.length; z++) {
        tot += selectedItemsFree[z].quantity;
      }
    }

    return tot;
  };

  const onClickAdd = useCallback(() => {
    if (product) {
      let finishedCompositionList = [...orderCompositions];
      const _observationField: OrderComposition = {
        id: v4(),
        description: "Observação",
        compositionId: "00000000-0000-0000-0000-000000000000",
        totalPrice: 0,
        orderCompositionItems: [
          {
            id: v4(),
            description: observationField.observation,
            isProductGeneralObservation: true,
            price: 0,
            quantity: 1,
            compositionId: "00000000-0000-0000-0000-000000000000",
            produtoId: "",
            compositionItemId: v4(),
            quantityFree: 0,
            quantityFreeSelected: 0,
            itemType: 0,
          },
        ],
      };

      finishedCompositionList.push(_observationField);

      for (let i = 0; i < finishedCompositionList.length; i++) {
        const finshedList = finishedCompositionList[i];
        for (let j = 0; j < finshedList.orderCompositionItems.length; j++) {
          const orderCompositionItem = finshedList.orderCompositionItems[j];
          if (orderCompositionItem.quantity <= 0) {
            finshedList.orderCompositionItems.splice(j, 1);
            j--;
          }
        }
      }

      addProductCart(
        product,
        1,
        finishedCompositionList,
        product.adultHood
      );

      onClose();
    }
  }, [
    addProductCart,
    observationField.observation,
    onClose,
    orderCompositions,
    product,
  ]);

  const onFinishCompostions = useCallback(
    (orderCompositionList: OrderComposition[], _minimo: boolean) => {
      setOrderCompositions(orderCompositionList);
    },
    []
  );

  const limitChars = 200;

  const handleChangeObservation = useCallback((observation: string) => {
    if (observation.length <= limitChars) {
      setObservationField({ observation });
    }
  }, []);

  const onImgError = (ev: React.ChangeEvent<HTMLImageElement>) => {
    ev.target.src = require("../../../../assets/images/no-image.png");
  };

  return (
    <div id={styles.ProductDetail}>
      <IconButton className={styles.close} onClick={onClose}>
        <Icon>close</Icon>
      </IconButton>

      <div
        className={styles.container}
        style={{
          padding: resolution === ResolutionType.FULL_HD ? 80 : 30,
        }}
      >
        <div className={styles.description}>
          <img
            src={product.thumbnailUrl}
            onErrorCapture={onImgError} 
            alt="Produto"
            style={{
              width: resolution === ResolutionType.FULL_HD ? 250 : 200,
              height: resolution === ResolutionType.FULL_HD ? 200 : 150,
            }}
          />
          <div
            style={{
              marginLeft: resolution === ResolutionType.FULL_HD ? 32 : 24,
            }}
          >
            <p
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 36 : 26,
                maxWidth: resolution === ResolutionType.FULL_HD ? 600 : 400,
              }}
              >
              {getProductName(product)}
            </p>
            <p
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 26 : 18,
                maxHeight: resolution === ResolutionType.FULL_HD ? 200 : 140,
                maxWidth: resolution === ResolutionType.FULL_HD ? 600 : 400,
              }}
            >
              {descriptionObject?.description}
            </p>
          </div>
        </div>

        <div className={styles.composition}>
          {product.compositions && (
            <CompositionList
              observation={observationField.observation}
              handleChangeObservation={handleChangeObservation}
              addToCard={onClickAdd}
              compostionFreeMax={product.maxQuantityFreeAdditional}
              onFinish={onFinishCompostions}
              compositions={product.compositions.filter(
                (it) => it.compositionItems.length > 0
              )}
              setSelectedItemsFree={setSelectedItemsFree}
              selectedItemsFree={selectedItemsFree}
              getTotalItemsFree={getTotalItemsFree}
              selectedItemsReplica={selectedItemsReplica}
              setSelectedItemsReplica={setSelectedItemsReplica}
              productBaseValue={product.price}
              generalObservation={product.productGeneralObservation}
              productSuggestions={product?.cartRecommendationByProduct ?? []}
            ></CompositionList>
          )}
        </div>
      </div>
    </div>
  );
};
